export const BILLING = "hardwareDelivery.BILLING";
export const EXISTING = "hardwareDelivery.EXISTING";
export const NEW = "hardwareDelivery.NEW";
